import React, { useState, useCallback } from 'react';
import PageTemplate, {
  pageCommonPropTypes,
  renderCmsComponents,
  renderComponent,
} from './templates/PageTemplate';
import axios from 'axios';
import { Paragraph, FormWrapper } from '@paypalcorp/brc-components';

const processComponentProps = ({ componentProps, componentType, pageInfo }) => {
  if (componentType !== 'ArticleRatingBanner') {
    return componentProps;
  }
  const { country, language, locale } = pageInfo;
  const handleSubmitRating = async ({ reviewComments, reviewRating }) => {
    const body = {
      entryId: pageInfo.pageEntryId,
      language,
      country,
      locale,
      request_type: 'FEEDBACK',
      entryTemplateId: 'L3ArticlePage',
      docId: pageInfo.pageDocId,
      environmentId: pageInfo.envId,
      tenantId: 'BRC',
      request_status: 'Success',
      message: reviewComments,
      review_rating_value: reviewRating,
    };
    if (pageInfo.isCMSPreview) {
      return Promise.resolve();
    }
    return axios.post(`/${country.toLowerCase()}/brc/article/articleReview`, {
      eventParams: body,
      _csrf: pageInfo.csrf,
    });
  };
  return {
    ...componentProps,
    handleSubmitRating,
  };
};

const renderGatedArticleTemplate = ({
  components,
  pageInfo,
  introParagraph,
}) => {
  const [showArticleComponents, setShowArticleComponents] = useState(false);

  let articleHeader;
  let formWrapper;
  const remainingComponents = [];

  components.forEach((componentData) => {
    const { componentType } = componentData;
    if (componentType === 'FormWrapper') {
      // eslint-disable-next-line no-unused-vars
      const { componentType, ...formWrapperProps } = componentData;
      formWrapper = formWrapperProps;
    } else if (componentType === 'ArticleHeader') {
      articleHeader = componentData;
    } else {
      remainingComponents.push(componentData);
    }
  });

  const changeFormVisibility = useCallback(
    (isFormHidden) => setShowArticleComponents(isFormHidden),
    [],
  );

  return (
    <>
      {articleHeader &&
        renderComponent({ componentData: articleHeader, pageInfo })}
      {introParagraph && <Paragraph {...introParagraph} />}
      {showArticleComponents &&
        renderCmsComponents(
          remainingComponents,
          pageInfo,
          processComponentProps,
        )}
      {formWrapper && (
        <FormWrapper
          {...formWrapper}
          onChangeFormVisibility={changeFormVisibility}
          isGatedForm
        />
      )}
    </>
  );
};
const ArticlePage = ({ content = {}, fpti = {}, pageInfo = {} }) => {
  const { header, footer } = content.globalComponents || {};
  const {
    components = [],
    subNav,
    globalDisclosure,
    articleStickyButton,
    introParagraph = null,
  } = content.pageData || {};
  const { isGatedArticle = false } = pageInfo;
  return (
    <PageTemplate
      header={header}
      footer={footer}
      fpti={fpti}
      subNav={subNav}
      pageInfo={pageInfo}
      globalDisclosure={globalDisclosure}
      articleStickyButton={articleStickyButton}
    >
      {isGatedArticle
        ? renderGatedArticleTemplate({
          components,
          pageInfo,
          introParagraph,
        })
        : renderCmsComponents(components, pageInfo, processComponentProps)}
    </PageTemplate>
  );
};

ArticlePage.propTypes = pageCommonPropTypes;

export default ArticlePage;
